export const CircleCheckGreen = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33333 0C3.73096 0 0 3.73096 0 8.33333C0 12.9357 3.73096 16.6667 8.33333 16.6667C12.9357 16.6667 16.6667 12.9357 16.6667 8.33333C16.6667 3.73096 12.9357 0 8.33333 0ZM11.3171 6.64577C11.5356 6.37862 11.4963 5.98486 11.2291 5.76628C10.962 5.5477 10.5682 5.58707 10.3496 5.85423L7.03693 9.90305L5.85861 8.72472C5.61453 8.48065 5.2188 8.48065 4.97472 8.72472C4.73065 8.9688 4.73065 9.36453 4.97472 9.60861L6.64139 11.2753C6.76625 11.4001 6.93811 11.4664 7.11447 11.4576C7.29083 11.4488 7.45524 11.3658 7.56706 11.2291L11.3171 6.64577Z"
      fill="currentColor"
    />
  </svg>
)

export default CircleCheckGreen
